import { Button } from '../../../button';
import { Col } from '../../../col';
import { Icon } from '../../../icon';
import { Row } from '../../../row';
import { Text } from '../../../typography';

type P = {
  fileName: string;
  removeUpload: () => void;
};

const DoneFileUpload = ({ fileName, removeUpload }: P) => (
  <div className="ui-video-status">
    <Row align="middle" className="ui-video-status__file-row" gutter={['xs', 0]}>
      <Col>
        <Icon icon="attachment-line" />
      </Col>

      <Col className="ui-video-status__file-name" flex="1">
        <Text ellipsis>{fileName}</Text>
      </Col>

      <Col>
        <Button
          className="ui-video-status__button"
          icon={<Icon icon="delete-2-line" />}
          onClick={() => {
            removeUpload();
          }}
          type="link-primary"
        />
      </Col>
    </Row>
  </div>
);

export default DoneFileUpload;
